import { cn } from "../../utils/cn";

interface LogoProps {
    size?: number;
    withWordmark?: boolean;
    className?: string;
}

/**
 * GameManager mark: a hexagonal server node with a live ember core. The hexagon
 * reads as a module/host; the glowing center is a running server ("alive").
 */
export const LogoMark = ({ size = 32 }: { size?: number }) => (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
        <defs>
            <linearGradient id="gm-ember" x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FF9D42" />
                <stop offset="1" stopColor="#FF5A2E" />
            </linearGradient>
        </defs>
        <path
            d="M16 3.2l11.1 6.4v12.8L16 28.8 4.9 22.4V9.6z"
            stroke="url(#gm-ember)"
            strokeWidth="2"
            strokeLinejoin="round"
        />
        <path d="M16 10.5l4.8 2.75v5.5L16 21.5l-4.8-2.75v-5.5z" fill="url(#gm-ember)" opacity="0.18" />
        <circle cx="16" cy="16" r="3.1" fill="url(#gm-ember)" />
    </svg>
);

export const Logo = ({ size = 32, withWordmark = true, className }: LogoProps) => (
    <div className={cn("flex items-center gap-2.5 select-none", className)}>
        <LogoMark size={size} />
        {withWordmark && (
            <span
                className="font-display font-semibold tracking-tight text-fg"
                style={{ fontSize: size * 0.56 }}
            >
                Game<span className="text-ember">Manager</span>
            </span>
        )}
    </div>
);
